import { connectedStore } from '../../store';
import constants from '../constants';
import getSettings from '../selectors/settings';

export default async function requestFlags(flags) {
  const store = connectedStore.get();
  const state = store.getState();
  const { requestFeatureFlags } = getSettings(state);

  const properties = {
    [constants.SYMBOL_SETTING]: {
      disableBlocking: true,
    },
  };

  const { flags: resolvedFlags } = await requestFeatureFlags({ properties, flags });

  return resolvedFlags;
}
